import util   from '../../common/AppUtil';

const ServerMode = 3;   // dbcservice
const ApiCode = "dbccheck";

export default {
  
  execute: function(action,params) {
    return util.callServerPost(ServerMode,ApiCode,params,action);
  },
}
  


// WEBPACK FOOTER //
// ./src/api/dbc/dbccheck.js